<button mat-icon-button (click)="popupVisible = true">
  <mat-icon class="secondary-text">chat</mat-icon>
</button>
<dx-popup
  *ngIf="popupVisible"
  [(visible)]="popupVisible"

  [title]="'ChatBox'"

  [showCloseButton]="true"
  [width]="'80%'"
  [height]="'80%'"

  [dragEnabled]="true"
  [resizeEnabled]="true"
  (onHiding)="closePopup()"

>
  <div class="chat-box-container">
    <app-chat-box></app-chat-box>
  </div>
</dx-popup>
